import NavBarDirective from './directives/NavBarDirective';
import 'edge/platform/widgets/pagestructure/module';
import 'edge/quoteandbind/app';
import 'edge/guidance/app';
import 'edge/faq/app';
import 'l10nModule';
import 'gw-portals-util-angular';
import 'edge/platform/facebook/module';
import 'edge/platform/segmentation/module';
import SetVersionDocumentTitle from 'gw-portals-platform-angular/versionName/SetVersionDocumentTitle';
import 'styles-portal/sass/modules.scss';
import AppConfig from '../../customer/js/src/edge/quoteandbind/ama/cpp/config/AppConfig.js';

export default angular.module('portal.app', ['ui.router', 'edge.platform.widgets.pagestructure', 'edge.platform.l10n', 'edge.quoteandbind.app', 'edge.guidance.app', 'edge.faq.app', 'edge.platform.util', 'edge.platform.facebook', 'edge.platform.campaign']).value('AppConfig', new AppConfig()).config(['QuestionSetServiceProvider', 'QUESTION_SETS_CONFIG', function (QuestionSetServiceProvider, QUESTION_SETS_CONFIG) {
    QuestionSetServiceProvider.addQuestionSets(QUESTION_SETS_CONFIG);
}]).config(['FaqServiceProvider', 'FAQ_CONFIG', function (FaqServiceProvider, FAQ_CONFIG) {
    FaqServiceProvider.setSections(FAQ_CONFIG.sections);
}]).config(['FacebookServiceProvider', 'FACEBOOK_CONFIG', 'DEBUG_MODE', function (FacebookServiceProvider, FACEBOOK_CONFIG, DEBUG_MODE) {
    FacebookServiceProvider.setDebugMode(DEBUG_MODE);
    FacebookServiceProvider.setAppId(FACEBOOK_CONFIG.appId);
    FacebookServiceProvider.setShareDialogData(FACEBOOK_CONFIG.shareDialog);
}]).config(['CampaignDataServiceProvider', 'CAMPAIGN_PARAMS_CONFIG', function (CampaignDataServiceProvider, CAMPAIGN_PARAMS_CONFIG) {
    CampaignDataServiceProvider.setUrlParamsConfig(CAMPAIGN_PARAMS_CONFIG.campaign);
}]).directive('gwPortalNavBar', NavBarDirective).constant('qnb-gateway-contact-details', {
    phoneNumber: '1-800-555-0199'
}).run(['$translate', 'ama.AppConfig', '$rootScope', function ($translate, AMAConfig, $rootScope) {

    $rootScope.AppConfig = AMAConfig;

    SetVersionDocumentTitle({
        $translate: $translate,
        // "portal.app.versionName.title[.${VERSION}]" l10n ID (with a version, if available for the app) will be used
        translationIdBase: 'portal.app.versionName.title'
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./app/js/portal/app.js
// module id = 869
// module chunks = 0